export const isTrackCrossTrack = track => track.isCross
export const isSessionCrossTrack = session => session.track.isCross



// WEBPACK FOOTER //
// ./src/app/predicates.js